module.exports = __webpack_public_path__ + "img/pedro.229beb5a.png";